import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { Product } from "../../../../gobalType";
import SpecialView from "../../components/SpecialProduct";

type PlantsSpecialSectionProps = {
  dataSpecial: Product[];
};

export function PlantsSpecialSection({ dataSpecial }: PlantsSpecialSectionProps) {
  return (
    <Box>
      <Typography
        sx={{
          fontWeight: "600",
          marginBottom: "0px",
          mt: 5,
          fontSize: { xs: 18, sm: 25 },
          textTransform: "uppercase",
          color: "#007F18",
        }}
        textAlign="center">
        Special Promotion - Limited Time Only!
      </Typography>
      <Box sx={{ textAlign: "center" }}>
        <SpecialView dataSpecials={dataSpecial} />
      </Box>
    </Box>
  );
}
